/* eslint-disable @typescript-eslint/naming-convention */
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { User } from '../@types';
import * as Constants from '../constants';
import { api, ApiResponse, throwError } from './BaseApi';

const cache = {
  CURRENT_USER: 'currentUser',
  SECTION_PROGRESS: 'sectionProgress',
  CONNECTIONS: 'connections',
};

export const getCurrentUser = async () => {
  const res: any = await api.post('users/auth');
  const { response, error } = await ApiResponse(res);
  if (error) return undefined;
  return response.user as User;
};

export const useCurrentUser = () =>
  useQuery(cache.CURRENT_USER, getCurrentUser);

export const getConnections = async () => {
  // return [
  //   {
  //     id: 'f2cb8436-2e8c-4c24-9a0e-8efc372c0587',
  //     username: 'MonaS',
  //     first_name: 'Mona',
  //     last_name: 'Schwartz',
  //     avatar: '/assets/demo/av8.png',
  //   },
  //   {
  //     id: 'c2fe6c07-09a0-4a3e-9800-cb572b4d7d84',
  //     username: 'SilviaR',
  //     first_name: 'Silvia',
  //     last_name: 'Rettaroli',
  //     avatar: '/assets/demo/av3.png',
  //   },
  // ];
  try {
    const res: any = await api.get('user_connections');
    const { response, error } = await ApiResponse(res);
    if (error) throw error;
    return response;
  } catch (err) {
    return err;
    // return throwError(err, 'There was a problem loading your progress.');
  }
};

export const useConnections = () =>
  useQuery(cache.CONNECTIONS, () => getConnections());

const evaluateProgress = (progress: any[]) => {
  const result = progress.map((p) => {
    const { id: prompt_id, user_progress } = p;
    return { prompt_id, completed: !!user_progress.length };
  });
  const numCompleted = result.filter((p) => !!p.completed).length;
  const pctCompleted = ((numCompleted / progress.length) * 100).toFixed(2);

  return {
    prompts: result,
    pct: pctCompleted,
  };
};

const getUserSectionProgress = async (
  userId: string,
  episodeSectionId: string
) => {
  try {
    const res: any = await api.get(
      `user_progress/${episodeSectionId}/${userId}`
    );
    const { response, error } = await ApiResponse(res);
    if (error) throw error;
    const newProg = evaluateProgress(response.progress);
    return newProg;
  } catch (err) {
    return throwError(err, 'There was a problem loading your progress.');
  }
};

export const useUserSectionProgress = (
  userId: string,
  episodeSectionId: string
) => {
  return useQuery(
    [cache.SECTION_PROGRESS, episodeSectionId],
    () => getUserSectionProgress(userId, episodeSectionId),
    {
      enabled: !!userId,
    }
  );
};

const saveProgress = async (props: any) => {
  const { prompt_id, user_id, answered = 0 } = props;
  try {
    const res: any = await api.post('user_progress/update', {
      json: {
        user_id,
        prompt_id,
        answered,
      },
    });
    const { response, error } = await ApiResponse(res);
    if (error) throw error;
    return evaluateProgress(response.progress);
  } catch (err) {
    return throwError(err, 'There was a problem saving your progress.');
  }
};

export const useSaveUserProgress = (episodeSectionId: string) => {
  const queryClient = useQueryClient();
  return useMutation(saveProgress, {
    onSuccess: (progress) => {
      // queryClient.invalidateQueries([cache.SECTION_PROGRESS, episodeSectionId]);
      if (progress) {
        queryClient.setQueryData(
          [cache.SECTION_PROGRESS, episodeSectionId],
          progress
        );
      }
    },
  });
};

export const useRequestConnection = (episodeSectionId: string) => {
  const queryClient = useQueryClient();
  return useMutation(saveProgress, {
    onSuccess: (progress) => {
      // queryClient.invalidateQueries([cache.SECTION_PROGRESS, episodeSectionId]);
      if (progress) {
        queryClient.setQueryData(
          [cache.SECTION_PROGRESS, episodeSectionId],
          progress
        );
      }
    },
  });
};

export const maybeEnrollEpisode = async (userId: string, episodeId: string) => {
  try {
    const res: any = await api.get(`user_enroll/${episodeId}/${userId}`);
    const { response, error } = await ApiResponse(res);
    console.log(response);
    return response;
    if (error) throw error;
  } catch (err) {
    return throwError(
      err,
      'There was a problem enrolling you in this episode.'
    );
  }
};
